/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.14.0
 * @since 1.14.0
 */

import { createAction } from '../../modules/app/createAction';
import {
    IWizardChangeLockSetStepValidPayload,
    TWizardChangeLockHandleNextAction,
    TWizardChangeLockSetParamsAction,
    TWizardChangeLockSetParamsPayload,
    TWizardChangeLockSetStepValidAction,
    TWizardChangeLockStartValidateAction,
} from './types/wizardChangeLockActionTypes';
import {
    WIZARD_CHANGE_LOCK_HANDLE_NEXT,
    WIZARD_CHANGE_LOCK_SET_PARAMS,
    WIZARD_CHANGE_LOCK_SET_STEP_VALID,
    WIZARD_CHANGE_LOCK_START_VALIDATE,
} from './wizardChangeLockConstant';

/*
* -------------------------------------------
*         Common Wizard Actions
* -------------------------------------------
*/

export const wizardChangeLockHandleNextAction = (): TWizardChangeLockHandleNextAction =>
    createAction(WIZARD_CHANGE_LOCK_HANDLE_NEXT);

export const wizardChangeLockSetParamsAction = (payload: TWizardChangeLockSetParamsPayload):
    TWizardChangeLockSetParamsAction =>
    createAction(WIZARD_CHANGE_LOCK_SET_PARAMS, payload);

export const wizardChangeLockStartValidateAction = ():
    TWizardChangeLockStartValidateAction => createAction(WIZARD_CHANGE_LOCK_START_VALIDATE);

export const wizardChangeLockSetStepValidAction = (payload: IWizardChangeLockSetStepValidPayload):
    TWizardChangeLockSetStepValidAction => createAction(WIZARD_CHANGE_LOCK_SET_STEP_VALID, payload);
